
export default {
  name: "humanity",
  props: {
    itemObj: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {}
  }
}
